import React, { useEffect, useState } from "react";
import colorSharp from "../assets/img/color-sharp-blue.png";
import colorSharp2 from "../assets/img/color-sharp2-blue.png";
import { db } from "../firebase";
import { collection, getDocs, query } from "firebase/firestore";
import "../css/skills.css";

export const Skills = () => {
  const [items, setItems] = useState([]);

  async function fetchListings() {
    try {
      const projectRef = collection(db, "skills");
      const q = query(projectRef);
      const querySnap = await getDocs(q);
      let projects = [];
      querySnap.forEach((doc) => {
        projects.push({
          id: doc.id,
          data: doc.data(),
        });
      });
      setItems(projects);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    fetchListings();
  }, []);

  const [hoveredItem, setHoveredItem] = useState(null);

  // Event handlers for mouse enter and leave
  const handleMouseEnter = (itemId) => {
    setHoveredItem(itemId);
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };

  const getSkillLevel = (percentage) => {
    if (percentage >= 90) {
      return "Expert";
    } else if (percentage >= 85) {
      return "Advanced";
    } else if (percentage >= 80) {
      return "Intermediate";
    } else {
      return "Beginner";
    }
  };

  return (
    <section className="skill" id="skills">
      <div className="container" style={{ marginTop: "70px" }}>
        <div className="col-12">
          <div className="skill-bx wow zoomIn">
            <div className="about-section">
              <h1 className="background-text">SKILLS</h1>
              <h1
                className="foreground-text"
                style={{ color: "#4DA1A9", fontWeight: "800" }}
              >
                SKILLS
                <div
                  className="underline"
                  style={{ backgroundColor: "#4DA1A9" }}
                ></div>
              </h1>
            </div>
            <div style={{display:"flex",justifyContent:"center",flexDirection:"column",alignItems:"center"}}>
              <div className="grid-containerSkill">
                {items.map((item) => (
                  <div>
                    <div
                    key={item.id}
                    style={{marginBottom:"10px"}}
                    className={`circleSkill ${
                      hoveredItem === item.id ? "darkenSkill" : ""
                    }`}
                    onMouseEnter={() => handleMouseEnter(item.id)}
                    onMouseLeave={handleMouseLeave}
                  >
                    <img
                      src={item.data.skillsLogo}
                      alt="CircleSkill"
                      className="circle-imageSkill"
                    />
                    {hoveredItem === item.id && (
                      <div className="overlaySkill">
                        <span style={{fontSize:"12px"}}>{getSkillLevel(item.data.skillsPercentage)}</span>
                        
                      </div>
                    )}
                  </div>
                  <span>{item.data.skillsName}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="Image" />
      <img className="background-image-right" src={colorSharp2} alt="Image" />
    </section>
  );
};
{
  /* {items.map((item) => (
                <div key={item.id} className="item">
                  <div className="item-image-container">
                    <img
                      src={item.data.skillsPercentage >= 90 ? meter90 : meter80}
                      alt={item.title}
                      className="item-image"
                    />
                    <div className="percentage-text">
                      {item.data.skillsPercentage}%
                    </div>
                  </div>
                  <h5 className="item-title">{item?.data.skillsName}</h5>
                </div>
              ))} */
}
